import React ,{useEffect}from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Translate from "../Multilanguage/Translate";
const HeaderAccountsPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const navigate = useNavigate();
  const location = useLocation();
  const redirectPage = projectInfo?.projectConfig?.config?.INITIAL_PAGE;
    
  return (
    <header className="accountsPageHeader" role="banner" aria-label="Account Page Header">
      <div className="left">
        <div className="logoContainer">
          <Link to={redirectPage === "LOGIN" ? "/login" : "/home"} aria-label="Home" 
          role="link">
            <h1>
              <img src={projectInfo?.projectConfig?.config?.LOGO} alt="Site Logo" />
            </h1>
          </Link>
        </div>
      </div>
      <div className="right" role="navigation" aria-label="Account Actions">
        {location?.pathname === "/register" ? (
          <button onClick={() => navigate("/login")}
            aria-label="Go to Login"
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') navigate("/login"); }}
          >
            <Translate textKey={'login'} />
          </button>
        ) : (
          <button onClick={() => navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? "/checkout" : "/register", { state: { ...location.state }, })}
            aria-label={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT ? projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT : "Register"}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? "/checkout" : "/register", { state: { ...location.state }, }); }}
          >
            {projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT ?  <Translate textKey={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT}/> : <Translate textKey={'register'} />}
          </button>
        )}
      </div>
    </header>
  );
};

export default HeaderAccountsPage;
